import { jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.255 4.756a3.255 3.255 0 1 1-6.51 0 3.255 3.255 0 0 1 6.51 0Zm-1.5 0C9.755 3.786 8.968 3 8 3c-.968 0-1.755.788-1.755 1.755 0 .968.787 1.756 1.755 1.756.968 0 1.755-.788 1.755-1.756ZM14.5 9.979v2.619l-1.5.401v-1.865L8 9.813l-5 1.321V13h9.999l.402 1.5H1.5V9.979L8 8.262l6.5 1.717Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  r as User
};
